import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ApiService from "../../../services/ApiService";
import { callAlert } from "../../../services/CommonService";
import { format } from "date-fns";
import QuizService from "../../../services/QuizService";
import QuizModal from "../../../components/Modals/QuizModal";

function QuizReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [quizData, setQuizData] = useState();

  const [show, setShow] = useState(false);

  function ScoreIndicator({ value, maxValue }) {
    const val = (value / maxValue) * 100;
    const deg = (180 / 100) * val;
    return (
      // <div className="indicator">
      //   <span className= {`bar ${(val < 50)?"red":"orange"}  ${val>80?"green":""} `}    style={{ transform: `rotate(${deg}deg)` }} />
      //   <span className="result">
      <div className="container">
        <span
          className={`fw-bold ${val < 50 ? "text-danger" : "text-warning"}  ${
            val > 80 ? "text-primary" : ""
          } `}
        >
          <span className="">{value}</span>%<span></span>
        </span>
      </div>
      // </div>
    );
  }

  const openQuizModal = (quiz) => {
    setQuizData(quiz); // Set the selected quiz data
    setShow(true); // Show the modal
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //       const response = await ApiService.publicPostRequest(
  //         `/quiz/findquiz`,{
  //           "quizId": quizData?.id,
  //           "courseName": quizData?.courseName,
  //         },
  //         true)
  //       }
  //   fetchData();
  // }, [quizData])

  const columns = [
    {
      name: "Course Name",
      selector: (d) => d.courseName,
      sortable: true,
      wrap: true,
    },

    {
      name: "Quiz Name",
      selector: (d) => d.quizName,
      sortable: true,
      wrap: true,
    },
    {
      name: "Start Date/Time  ",
      selector: (d) => d.startTime,
      sortable: true,
      cell: (d) => [
        <div className="">
          {format(new Date(d.startTime), "dd/MMM hh:mm a")}
        </div>,
      ],
    },

    {
      name: "Score",
      // selector: (d) => d.percentage +"%",
      selector: "",
      sortable: true,
      // width: "170px",
      cell: (d) => [
        <ScoreIndicator value={d?.percentage} maxValue={100} />,

        /*  <div
          className="progress mt3 mb-2 w-100"
          title={d?.percentage + "%"}
          style={{ height: 4 }}
        >

          <div
            className="progress-bar"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: d?.percentage + "%" }}
          ></div>
        </div>, */
      ],
    },
    {
      name: "Status",
      selector: (d) => d.status,
      sortable: true,
    },

    {
      name: "Action",
      selector: "",
      sortable: false,
      // width:"170px",
      cell: (d) => [
        <>
          {d.status === "COMPLETE" && (
            <button
              onClick={handleClick.bind(this, d)}
              className="btn btn-success links f12 "
              icon="edit"
            >
              {" "}
              Download{" "}
            </button>
          )}
          {d.status === "RETRY" && (
            <button
              key={d.id}
              className="btn btn-danger  links f12"
              onClick={() => openQuizModal(d)} // Pass the quiz data when retrying quiz
            >
              Retry
            </button>
          )}
          {d.status === "PENDING" && (
            <button
              key={d.id}
              className="btn btn-primary  links f12"
              onClick={() => openQuizModal(d)} // Pass the quiz data when retrying quiz
            >
              Start
            </button>
          )}
          {d.status === "INPROGRESS" && (
            <button
              key={d.id}
              className="btn btn-primary  links f12"
              onClick={() => openQuizModal(d)} // Pass the quiz data when retrying quiz
            >
              Resume
            </button>
          )}
        </>,
        // d.status === "COMPLETE" ? (
        //   <button
        //     onClick={handleClick.bind(this, d)}
        //     className="btn btn-success  links  "
        //     icon="edit"
        //   >
        //     {" "}
        //     Download Report{" "}
        //   </button>
        // ) : (
        //   <button
        //     key={d.id}
        //     className="btn btn-primary  links"
        //     onClick={() => openQuizModal(d)} // Pass the quiz data when retrying quiz
        //   >
        //     Quiz Retry
        //   </button>
        // ),
      ],
    },
  ];

  const handleClick = (quiz) => {
    QuizService.downloadReports(quiz?.id);
  };

  useEffect(() => {
    if (loading) {
      tableList();
    }
  }, []);
  useEffect(() => {
    tableList();
  }, [show]);

  function tableList() {
    ApiService.publicGetRequest("/quiz/quiz-summary", true)
      .then((res) => {
        if (res.data?.resultCode == 1 || res.data?.resultCode == 404) {
          setData(res.data.data ? res.data.data : []);
          setLoading(false);
        } else {
          callAlert("", res?.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
        setLoading(false);
      });
  }

  return (
    <div>
      {!loading && (
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          //className="table"
          //keys="id"
          //fixedHeader
          //selectableRows
        />
      )}
      <QuizModal show={show} setShow={setShow} quizData={quizData} />
      {/* <QuizModal show={show} setShow = {setShow}/> */}
    </div>
  );
}
export default QuizReport;
